import React from 'react';
import Icon from '@material-ui/core/Icon';
import withStyles from '@material-ui/core/styles/withStyles';
import Wifi from '@material-ui/icons/Wifi';
import Kitchen from '@material-ui/icons/Kitchen';
import Toys from '@material-ui/icons/Toys';
import Fireplace from '@material-ui/icons/Fireplace';
import Restaurant from '@material-ui/icons/Restaurant';
import LocalDining from '@material-ui/icons/LocalDining';
import DirectionsCar from '@material-ui/icons/DirectionsCar';
import DirectionsBike from '@material-ui/icons/DirectionsBike';
import LaundryImage from '../../../../images/amenities/laundry.jpeg';
import KettleImage from '../../../../images/amenities/kettle.jpeg';
import MicrowaveImage from '../../../../images/amenities/microwave.jpeg';
import CoinLaundryImage from '../../../../images/amenities/coin_laundry.jpeg';
import TowelImage from '../../../../images/amenities/towel.jpeg';
import BathTowelImage from '../../../../images/amenities/bath_towel.jpeg';
import ShampooImage from '../../../../images/amenities/shampoo.jpeg';
import HairdryerImage from '../../../../images/amenities/hairdryer.jpeg';
import RiceCookerImage from '../../../../images/amenities/rice_cooker.jpeg';
import ClothesHangerImage from '../../../../images/amenities/clothes_hanger.jpeg';
import DeskImage from '../../../../images/amenities/desk.jpeg';
import CleaningToolsImage from '../../../../images/amenities/cleaning_tools.jpeg';

const FaIcon = withStyles((theme) => ({
  root: {
    fontSize: theme.typography.pxToRem(18),
    width: '1.5em',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}))(Icon);

const icons = {
  wifi: <Wifi />,
  refrigerator: <Kitchen />,
  microwave: <img src={MicrowaveImage} width={24} alt="電子レンジ" />,
  fan: <Toys />,
  heating: <Fireplace />,
  laundry: <img src={LaundryImage} width={24} alt="洗濯機（無料）" />,
  laundry_detergent: <FaIcon className="fas fa-prescription-bottle" />,
  kettle: <img src={KettleImage} width={24} alt="湯沸かしポット" />,
  kitchen: <Restaurant />,
  cooking_tools: <LocalDining />,
  coin_laundry: (
    <img src={CoinLaundryImage} width={24} alt="コインランドリー" />
  ),
  towel: <img src={TowelImage} width={24} alt="タオル" />,
  bath_towel: <img src={BathTowelImage} width={24} alt="バスタオル" />,
  shampoo: (
    <img
      src={ShampooImage}
      width={24}
      alt="シャンプー・リンス・ボディーソープ"
    />
  ),
  hairdryer: <img src={HairdryerImage} width={24} alt="ドライヤー" />,
  rice_cooker: <img src={RiceCookerImage} width={24} alt="炊飯器" />,
  clothes_hanger: <img src={ClothesHangerImage} width={24} alt="ハンガー" />,
  car: <DirectionsCar />,
  bicycle: <DirectionsBike />,
  desk: <img src={DeskImage} width={24} alt="机（仕事・勉強用）" />,
  cleaning_tools: <img src={CleaningToolsImage} width={24} alt="掃除用具" />,
};

export default icons;
